var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameworkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.496,
    height: 27.495,
    viewBox: "0 0 27.496 27.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13870 -8226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.147,352.19v0h-1.289a1.611,1.611,0,0,0-1.611,1.611v6.977a1.611,1.611,0,0,0,1.611,1.611h4.511a1.611,1.611,0,0,0,1.611-1.611v-6.977a1.611,1.611,0,0,0-1.611-1.611h-1.289v0Z",
    transform: "translate(13608.634 7891.102)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.625,352.188h-1.289v0H475.4v0h-1.289A1.611,1.611,0,0,0,472.5,353.8v6.977a1.611,1.611,0,0,0,1.611,1.611h4.511a1.611,1.611,0,0,0,1.611-1.611V353.8a1.611,1.611,0,0,0-1.611-1.611Z",
    transform: "translate(13417.26 7891.107)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.148,237.137h1.289a.322.322,0,0,0,.322-.322V235.2a2.255,2.255,0,0,0-2.255-2.255h-7.626V232.2a.322.322,0,0,0-.322-.322h-1.289a.322.322,0,0,0-.322.322v.752h-7.626a2.255,2.255,0,0,0-2.255,2.255v1.611a.322.322,0,0,0,.322.322h1.289a.322.322,0,0,0,.322-.322V235.2a.322.322,0,0,1,.322-.322h7.626v1.933a.322.322,0,0,0,.322.322h1.289a.322.322,0,0,0,.322-.322v-1.933H148.5a.322.322,0,0,1,.322.322v1.611a.322.322,0,0,0,.322.322Z",
    transform: "translate(13743.837 8005.511)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.239,10.745h14.392a1.611,1.611,0,0,0,1.611-1.611V1.616A1.611,1.611,0,0,0,186.631.005H172.239a1.611,1.611,0,0,0-1.611,1.611V9.134a1.611,1.611,0,0,0,1.611,1.611Zm9.752-6.863a.668.668,0,0,1,1.044-.835l1.527,1.91h0a.665.665,0,0,1,0,.835L183.034,7.7h0a.668.668,0,0,1-1.043-.835l1.194-1.491Zm-3.643,3.252.875-3.819a.668.668,0,0,1,1.3.3l-.875,3.819a.665.665,0,0,1-.651.52.673.673,0,0,1-.652-.818Zm-4.042-2.177,1.523-1.91a.668.668,0,1,1,1.045.834l-1.191,1.493,1.191,1.493a.668.668,0,0,1-1.045.834l-1.523-1.91a.666.666,0,0,1,0-.834Z",
    transform: "translate(13704.313 8225.995)",
    fill: "#169cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.609,362.393H76.12a1.611,1.611,0,0,0,1.611-1.611V353.8a1.611,1.611,0,0,0-1.611-1.611H74.831v0H72.9v0H71.609A1.611,1.611,0,0,0,70,353.8v6.977a1.611,1.611,0,0,0,1.611,1.611Z",
    transform: "translate(13800.002 7891.103)",
    fill: "#169cc5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameworkIcon);
export default __webpack_public_path__ + "static/media/framework-icon.b529cac6e1ddbe3c9ab4d450903ff1ed.svg";
export { ForwardRef as ReactComponent };